'use client';
import { useEffect, useState } from 'react';

export const useLocalStorage = () => {
  const [localStorage, setLocalStorage] = useState<Storage>();

  useEffect(() => {
    setLocalStorage(window.localStorage);
  }, []);

  return localStorage;
};
